exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.toogle-el[data-v-5d4d1514] {\n  display: none;\n}\n.container-align[data-v-5d4d1514] {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n}\n#container-realtime-form[data-v-5d4d1514]{\n   margin-top: 40px;\n}\n", ""]);

// exports
